import AxiosInstance from '../config/AxiosInstance';

const getSchedules = async (payload: any) => {
  try {
    const { data } = await AxiosInstance.get('/api/core/schedules', {
      params: {
        page: payload.page,
        limit: payload.limit,
        searchValue: payload.searchValue,
      },
    });
    return { data };
  } catch (error) {
    throw error;
  }
};

const getDetailsSchedules = async (id: string) => {
  try {
    const { data } = await AxiosInstance.get('/api/core/schedules/' + id);
    return { data };
  } catch (error) {
    throw error;
  }
};

const createSchedules = async (payload: any) => {
  try {
    const { data } = await AxiosInstance.post('/api/core/schedules', payload);
    return { data };
  } catch (error) {
    throw error;
  }
};

const updateSchedules = async (id: string, payload: any) => {
  try {
    const { data } = await AxiosInstance.put('/api/core/schedules/' + id, payload);
    return { data };
  } catch (error) {
    throw error;
  }
};

const deleteSchedules = async (id: string) => {
  try {
    const { data } = await AxiosInstance.delete('/api/core/schedules/' + id);
    return { data };
  } catch (error) {
    throw error;
  }
};

export { getSchedules, getDetailsSchedules, createSchedules, updateSchedules, deleteSchedules };
